import { Parent } from './../../class/parent.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { FileService } from '../file.service';

@Component({
  selector: 'upload-file',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent extends Parent implements OnInit {

  form: FormGroup;
  progress: number = 0;
  selected_file: boolean = false;

  public url;
  public archivo;
  @Input() nombre: string;
  @Input() dni: string;
  @Input() item: number;
  @Output() result = new EventEmitter();

  constructor(
    public fb: FormBuilder,
    public fileService: FileService
  ) {
    super();
    this.form = this.fb.group({
      file_name: [null],
      file_data: [null]
    })
  }

  ngOnInit() { }

  uploadFile(event) {
    if (event.target.files[0].size > 10000000) {
      this.mensajePopup.alertaValidacion(false, 'TAMAÑO EXCEDIDO!!', 'El tamaño del archivo pdf excede los 10MB');
      return;
    }
    if (this.nombre === 'foto') {
      if (!this.valido_archivo_image(event.target.value)) {
        this.mensajePopup.alertaValidacion(false, 'IMAGEN O ARCHIVO NO VALIDO!!', 'Subir solo imagenes con extension .jpg, .jpeg, .png');
        return;
      } else if (event.target.files && event.target.files[0]) {

        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.url = event.target.result;
        }
        reader.readAsDataURL(event.target.files[0]);
      }
    } else {
      if (this.nombre === 'activo') {
        if (!this.valido_archivo_txt(event.target.value)) {
          this.mensajePopup.alertaValidacion(false, 'NO ES HTML!!', 'Subir solo archivos .html');
          return;
        }
      } else {
        if (!this.valido_archivo_pdf(event.target.value)) {
          this.mensajePopup.alertaValidacion(false, 'NO ES PDF!!', 'Subir solo archivos .pdf');
          return;
        }
      }
    }
    this.selected_file = true;
    this.form.get('file_name').setValue(event.target.value);
    const file = (event.target as HTMLInputElement).files[0];
    this.form.patchValue({
      file_data: file
    });
    this.form.get('file_data').updateValueAndValidity()
    if (this.nombre === 'activo') {
      this.subirArchivosActivo();
    }
    else {
      this.subirArchivos();
    }
  }

  subirArchivos() {
    this.fileService.upload_file_personal(this.form.value.file_data, this.dni, this.nombre)
      .subscribe((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.mensajePopup.alertaNotificacion('INFO', 'Archivo enviado al servidor', 'info');
            break;
          case HttpEventType.ResponseHeader:
            this.mensajePopup.alertaNotificacion('INFO', 'Archivo recibido', 'info');
            break;
          case HttpEventType.UploadProgress:
            this.progress = Math.round(event.loaded / event.total * 100);
            //this.mensajePopup.alertaNotificacion('INFO',`Subido! ${this.progress}%`,'info');
            break;
          case HttpEventType.Response:
            this.mensajePopup.alertaNotificacion('INFO', 'Archivo ' + this.form.value.file_name + ' fue subido correctamente', 'info');
            setTimeout(() => {
              this.progress = 0;
              this.selected_file = false;
              this.form.get('file_name').setValue(null);
              this.result.emit({
                success: true,
                nombre: this.nombre,
                dni: this.dni,
                item: this.item,
                url: this.url,
                archivo: this.archivo
              });
            }, 1500);
        }
      });
  }
  subirArchivosActivo() {
    this.fileService.upload_file_activo(this.form.value.file_data, this.dni, this.nombre)
      .subscribe((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.mensajePopup.alertaNotificacion('INFO', 'Archivo enviado al servidor', 'info');
            break;
          case HttpEventType.ResponseHeader:
            this.mensajePopup.alertaNotificacion('INFO', 'Archivo recibido', 'info');
            break;
          case HttpEventType.UploadProgress:
            this.progress = Math.round(event.loaded / event.total * 100);
            //this.mensajePopup.alertaNotificacion('INFO',`Subido! ${this.progress}%`,'info');
            break;
          case HttpEventType.Response:
            this.mensajePopup.alertaNotificacion('INFO', 'Archivo ' + this.form.value.file_name + ' fue subido correctamente', 'info');
            setTimeout(() => {
              this.progress = 0;
              this.selected_file = false;
              this.form.get('file_name').setValue(null);
              this.result.emit({
                success: true,
                nombre: this.nombre,
                dni: this.dni,
                item: this.item,
                url: this.url,
                archivo: this.archivo
              });
            }, 1500);
        }
      });
  }

  valido_archivo_pdf(name_file: string): boolean {
    const name = name_file.split('.');
    return name[name.length - 1] === 'pdf';
  }

  valido_archivo_txt(name_file: string): boolean {
    const name = name_file.split('.');
    return name[name.length - 1] === 'txt' || name[name.length - 1] === 'html';
  }

  valido_archivo_image(name_file: string): boolean {
    const name = name_file.split('.');
    this.archivo = 'foto_' + this.dni + '.' + name[name.length - 1];
    return name[name.length - 1] === 'jpg' || name[name.length - 1] === 'jpeg' || name[name.length - 1] === 'png' || name[name.length - 1] === 'PNG';
  }
}
